import { Status } from '../types'

interface Props {
    mps?: number
    ewt?: number
    variance?: number
    isInaccurate?: boolean
    isLowFrequency?: boolean
    expected?: number
    actual?: number
    value: number
}

export const getScoreStatus = ({ mps, ewt, variance, isInaccurate, isLowFrequency, value }: Props): Status => {
    if (!value) {
        return Status.noValue
    }

    if (variance === undefined && !(mps !== undefined && ewt !== undefined)) {
        return Status.out
    }

    if (isInaccurate) {
        return Status.inaccurate
    }

    if (isLowFrequency && variance) {
        if (!variance) return Status.out
        if (variance < -2) return Status.good
        if (variance < 0) return Status.disruption
        return Status.bad
    }

    const roundedMps = mps ?? 0
    const roundedEwt = ewt ?? 0
    const roundedVariance = variance ? variance : undefined

    const calculatedVariance = roundedVariance !== undefined ? roundedVariance : roundedMps - roundedEwt

    if (calculatedVariance > 0.1) {
        return Status.good
    }

    if (calculatedVariance < 0.1 && calculatedVariance > 0.01) {
        return Status.disruption
    }

    if (calculatedVariance <= 0.01) {
        return Status.bad
    }
    return Status.out
}
